// test1985
(1985 && 0);
